<template>
    <div class="product">
      <Header
      :headerBgc="state.headerBgc"
      :showLogo="state.showLogo"
      :boxShadows="state.boxShadows"
      :title-color="state.titleColor"
      @titleClick="titleClick"
      @menuClick="menuClick"/>
      <div class="about_con">
        <div class="top">
          <p data-aos="fade-up" data-aos-duration="1000">{{ $t('product.pageTitle') }}</p>
        </div>
        <div class="list">
          <div class="name yourButton" :class="state.active===index?'act':''" @click="handleList(index)" v-for="(item,index) in tabList" :key="item.id">{{item.name}}</div>
        </div>
        <!-- 睿长太肠癌检测 -->
        <div class="star_team" v-show="state.active===0">
          <div class="left">
            <img src="@/assets/img/rui.png" alt="">
          </div>
          <div class="right">
            <div class="title">{{ $t('product.ruichangtai.tubeTitle') }}</div>
            <div class="desc">
                {{ $t('product.ruichangtaiDesc.line1') }}<br>
                {{ $t('product.ruichangtaiDesc.line2') }}<br>
                {{ $t('product.ruichangtaiDesc.line3') }}<br>
                {{ $t('product.ruichangtaiDesc.line4') }}
            </div>
            <a class="btn buy-btn" href="https://item.m.jd.com/product/10045305754662.html" target="_blank" rel="noopener noreferrer">{{ $t('common.buyNow') }}</a>
          </div>
        </div>
        <!-- 产品设备 -->
        <div class="com_desc" v-show="state.active===1">
         <div class="prolist" v-for="(item,index) in prolist" :key="index" @click="proDetail(index)">
            <div class="l">
                <img :src="item.img" alt="">
            </div>
            <div class="r">
                <div class="name">{{ item.name }}</div>
                <div class="desc">{{ item.desc }}</div>
            </div>
        </div>
        </div>
        <!-- 在研产品 -->
        <div class="develop" v-show="state.active===2">
          <div class="fz">{{ $t('product.research.name') }}</div>
           <div class="pro_box">
            <div class="proing" v-for="(item,index) in proingList" :key="index">
            <div class="name">{{ item.name }}</div>
            <div class="zai">（{{ $t('product.research.status') }}）</div>
            <!-- <div class="tip">{{ item.tip }}</div> -->
            <div class="b">{{ $t('product.research.comingSoon') }}</div>
          </div>
           </div>
        </div>
        <!-- 产品试剂 -->
        <div class="cpsj" v-show="state.active===3">
           <div class="le">
            <div class="tit">{{ $t('product.reagent.name') }}</div>
            <div class="cpsj_list" :class="state.cpsjAct===index&&state.cpsjAct!==2?'after':'line'" v-for="(item,index) in cpsjList" :key="index" :style="{cursor: (index===2 ? 'not-allowed' : 'pointer')}" @click="handleCpsj(index)">
              <div class="name" :class="state.cpsjAct===index&&state.cpsjAct!==2?'act':''"> {{ item.name }}</div>
              <img v-show="state.cpsjAct===index&&state.cpsjAct!==2" src="/mimg/right_act.png" alt="">
            </div>
           </div>
           <div class="ri" v-if="state.cpsjAct===0">
            <img src="../assets/img/tct.png" alt="">
            <span>{{ $t('product.reagent.items.pcrProbeDesc') }}</span>
            <div class="btn" @click="navigateTo(localePath(`/proDetail/${5}`))">{{ $t('common.learnMore') }}</div>
           </div>
           <div class="ri" v-if="state.cpsjAct===1">
            <img src="../assets/img/last.png" alt="">
            <span>{{ $t('product.reagent.items.columnDesc') }}</span>
            <div class="btn" @click="navigateTo(localePath(`/proDetail/${8}`))">{{ $t('common.learnMore') }}</div>
           </div>
        </div>
        <!-- 透气细胞培养器 -->
        <div class="xibao" v-show="state.active===4">
          <div class="box">
            <div class="item">
              <div class="img">
                <img src="../assets/img/sl.png" alt="">
              </div>
              <div class="name">SL-CAB-C100</div>
              <div class="butt" @click="navigateTo(localePath(`/proDetail/${6}`))">{{ $t('common.learnMore') }}</div>
            </div>
            <div class="item">
              <div class="img">
                <img class="se" src="../assets/img/se.png" alt="">
              </div>
              <div class="name">SE-CAB-C100</div>
              <div class="butt" @click="navigateTo(localePath(`/proDetail/${7}`))">{{ $t('common.learnMore') }}</div>
            </div>
            <div class="item">
              <div class="img">
                <img class="sl10" src="../assets/img/sl10.png" alt="">
              </div>
              <div class="name">SL-CAB-C10</div>
              <div class="butt jj">{{ $t('product.research.comingSoon') }}</div>
            </div>
          </div>
        </div>
      </div>
      <NewFooter />
    </div>
  </template>
  
  <script setup>
  import {reactive,onMounted,onUnmounted,ref,computed} from 'vue'
  import { useAppStore } from '../store/app'
  const router = useRouter()
  const route =useRoute()
  const { t } = useI18n()
  const localePath = useLocalePath()
  const { $aos } = useNuxtApp()
  const { activeNum,setActive } = useAppStore()

  useSeoMeta({
    title: () => t('product.seoTitle'),
    description: () => t('product.seoDescription'),
    ogTitle: () => t('product.seoTitle'),
    ogDescription: () => t('product.seoDescription'),
    ogType: 'website',
  })
 
  const lineChange =ref(null)

  const tabList = computed(() => [
    { name: t('product.ruichangtai.name'), id: 1 },
    { name: t('product.equipment.name'), id: 2 },
    { name: t('product.research.name'), id: 3 },
    { name: t('product.reagent.name'), id: 4 },
  ])

  // 产品设备列表：名称与描述从语言包读取，语言切换时自动更新
  const prolist = computed(() => [
    { key: 'digitiger9800', img: '/pro/1.png' },
    { key: 'capReady6600', img: '/pro/2.png' },
    { key: 'nucleoTidy9000', img: '/pro/3.png' },
    { key: 'pcReady9600', img: '/pro/4.png' },
    { key: 'pcReady8800', img: '/pro/5.png' },
  ].map((item) => ({
    name: t(`product.equipment.items.${item.key}.name`),
    desc: t(`product.equipment.items.${item.key}.desc`),
    img: item.img,
  })))

  // 在研产品列表
  const proingList = computed(() => ['breastCancer', 'gastricCancer', 'nasopharyngealCancer', 'pancreaticCancer'].map((key) => ({
    name: t(`product.research.items.${key}`),
    tip: t(`product.research.items.${key}Tip`),
  })))

  // 产品试剂列表
  const cpsjList = computed(() => [
    { name: t('product.reagent.items.pcrProbe') },
    { name: t('product.reagent.items.pcrProbeWithSpace') },
    { name: t('product.reagent.items.columnComingSoon') },
  ])

  const state =  reactive({
    act:0,
    headerBgc:'',
    showLogo:true,
    titleColor:'#fff',
    boxShadows:'',
    active:0,
    actCom: 0,
    cpsjAct:0
  })
  function proDetail(index){
      // state.headerBgc='#fff'
      // state.showLogo=false
      // state.titleColor="#000"
      // state.boxShadows='0px 1px 8px 0px rgba(0,0,0,0.09)'
      navigateTo(localePath(`/proDetail/${index}`))

  }
  const handleCpsj =(index)=>{
    state.cpsjAct = index
    if(index===2){
      state.cpsjAct=0
    }
  }
  const handleList=(index)=>{
    state.active = index
    setActive(index)
  }
  const handleCom=(index)=>{
    state.actCom = index
  }
  const prevCom=()=>{
     if (state.actCom > 0) {
        state.actCom--
    }
  }
  const nextCom=()=>{
    if (state.actCom < state.comList.length - 1) {
      state.actCom++
    }
  }
  const prevYear=()=>{
     if (state.actY > 0) {
        state.actY--
        lineChange.value.onClickYear(state.actY)
    }
  }
  const nextYear=()=>{
    if (state.actY < state.years.length - 1) {
      state.actY++
      lineChange.value.onClickYear(state.actY)
    }
  }
  const titleClick=(id)=>{
    if (id == 11) {
    setActive(0)
      navigateTo(localePath(`/about`))
    }else if(id==22){
      setActive(0)
      navigateTo(localePath(`/product`))
    } else if (id == 33) {
      navigateTo(localePath(`/health`))
    } else if (id == 44) {
      setActive(0)
      navigateTo(localePath(`/contact`))
    } else {
      navigateTo(localePath(`/newsCenter`))
    }
  }
  const menuClick =(e,path)=>{
  let id = +e
    navigateTo(path)
    if(path.includes('/about')){
      setActive(+id-1)
      return
    }
    if(path.includes('/product')){
      state.active = id-6
      setActive(+id-6)
      return
    }
    if(path.includes('/health')){
      return
    }
    if(path.includes('/contact')){
      state.active = id-13
      setActive(+id-13)
      return
    }
}
  function handleScroll() {
    let top = Math.floor(document.documentElement.scrollTop || document.body.scrollTop);
    if(top>=80){
      state.headerBgc='#fff'
      state.showLogo=false
      state.titleColor="#000"
      state.boxShadows='0px 1px 8px 0px rgba(0,0,0,0.09)'
    } else{
      state.headerBgc=''
      state.showLogo=true
      state.titleColor="#fff"
      state.boxShadows=''
    }
  }
  onMounted(()=>{
    const tab = Number(route.query.tab)
    state.active = (!isNaN(tab) && tab >= 0 && tab < tabList.value.length) ? tab : activeNum
    setActive(state.active)
      $aos().init({
        easing: 'ease-out-back',
        duration: 2000,
        once:true
    })
    window.addEventListener('scroll', handleScroll)
  })
  onUnmounted(()=>{
   window.removeEventListener('scroll', handleScroll)
   localStorage.removeItem('counter')
  })
  </script>
  
  <style lang="less" scoped>
  .product{
    .about_con{
      width: 100%;
      background-color: #fff;
      position: relative;
      .top{
        background: url('../assets/img/pro.png');
        // background: url('../assets/img/proo.png');
        background-size: cover;
        background-position: center;
        width: 100%;
        height: 200px;
        p{
          font-size: 18px;
          text-shadow: 2px 2px 5px rgba(0, 0, 0, 0.5);
          font-weight: 700;
          color: #fff;
          padding-top: 80px;
          text-align: center;
          // padding-left: 100px;
          transition: transform 0.3s ease, color 0.3s ease;
        }
        .p_act{
          transform: translateY(-30px); /* 鼠标经过时上移文字 */
          color: #333; /* 鼠标经过时加深文字颜色 */
        }
      }
      .list{
        display: flex;
        align-items: center;
        justify-content: center;
        box-shadow: 0px 1px 20px 0px rgba(0, 0, 0, 0.13);
        height: 34px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, -50%);
        .name{
          background-color: #fff;
          width: 120px;
          height: 34px;
          line-height: 34px;
          text-align: center;
          cursor: pointer;
          color: #5A5A5A;
          transition: transform 0.3s ease, background-color 0.7s ease; /* 添加过渡效果 */
          &:hover{
            background-color: #00A0E9;
            color: #fff;
          }
        }
        .act{
          background-color: #00A0E9;
          color: #fff;
        }
      }
       // 企业介绍
      .com_desc{
        background: #F8F9FB;
        width: 100%;
        padding-top: 40px;
        padding-bottom: 100px;
        .prolist{
            display: flex;
            align-items: center;
            justify-content: center;
            margin-bottom: 20px;
            width: 75%;
            border-bottom: 1px solid #E6E6E6;
            margin: auto;
            padding-bottom: 15px;
            padding-top: 15px;
            cursor: pointer;
            &:last-child{
                border-bottom: none;
            }
            &:hover{
                .l{
                    img{
                        transform: scale(1.1);
                        border: 1px solid #00A0E9;
                        border-radius: 6px;
                    }
                }
                .r{
                    .desc{
                        color: #00A0E9;
                    }
                }
            }
            .l{
                margin-right: 40px;
                width: 110px;
                height: 110px;
                img{
                    width: 100%;
                    height: 100%;
                    transition: transform 0.3s ease;
                }
            }
            .r{
               width: 55%;
               .name{
                font-size: 10px;
                color: #000;
                margin-bottom: 20px;
               }
               .desc{
                    color: #b5b6b6;
                    line-height: 16px;
               }
            }
        }
      }
      // 明星团队
      .star_team{
          width: 100%;
          display: flex;
          justify-content: center;
          padding-top: 60px;
          padding-bottom: 100px;
          .left{
            width: 235px;
            height: 231px;
            margin-right: 40px;
            animation: moveLeft 1.2s ease-in-out forwards;
            img{
              width: 100%;
              height: 100%;
            }
          }
          .right{
            animation: moveRight 1.2s ease-in-out forwards;
            padding-top: 20px;  
            .title{
              font-size: 12px;
              font-weight: bold;
              margin-bottom: 20px;
            }
            .desc{
              width: 286px;
              height: 132px;
              line-height: 16px;
              color: #666666;
            }
            .btn{
                    width: 58px;
                    height: 22px;
                    line-height: 22px;
                    text-align: center;
                    color: #fff;
                    font-size:8px;
                    background: #00A0E9;
                    border: 1px solid #00A0E9;
                    border-radius: 11px;
                    cursor: pointer;
                    margin-top: -30px;
                }
                a.buy-btn {
                  display: inline-block;
                  text-decoration: none;
                }
          }
          @keyframes moveLeft {
                    0% {
                      transform: translateX(-100%);
                    }
                    50% {
                      transform: translateX(0);
                    }
                    70% {
                      transform: translateX(-6px);
                    }
                    80% {
                      transform: translateX(10px);
                    }
                    90% {
                      transform: translateX(-3px);
                    }
                    100% {
                      transform: translateX(0);
                    }
                  }
          @keyframes moveRight {
                  0% {
                    transform: translateX(100%);
                  }
                  50% {
                    transform: translateX(0);
                  }
                  70% {
                    transform: translateX(6px);
                  }
                  80% {
                    transform: translateX(-10px);
                  }
                  90% {
                    transform: translateX(3px);
                  }
                  100% {
                    transform: translateX(0);
                  }
                }
        }
      .develop{
          width: 100%;
          padding-bottom: 100px;
          background-color: #fff;
          .fz{
            font-size: 16px;
            font-weight: bold;
            width: 100%;
            text-align: center;
            margin-top: 40px;
            margin-bottom: 30px;
          }
          .pro_box{
             display: flex;
            align-items: center;
            justify-content: center;
            .proing{
            width: 108px;
            height: 175px;
            text-align: center;
            background: #F8F9FB;
            margin-right: 18px;
            padding: 30px 8px;
            box-sizing: border-box;
            &:hover{
              border: 1px solid #00A0E9;
            }
            .name{
              // font-size: 12px;
              font-family: Source Han Sans CN;
              font-weight: 700;
              color: #333333;
            }
            .zai{
              color: #00A0E9;
              margin: 12px 0 16px 0;
            }
            .tip{
                color: #999999;
            }
            .b{
              width: 53px;
              height: 18px;
              border: 1px solid #00A0E9;
              color: #00A0E9;
              border-radius: 9px;
              margin: auto;
              margin-top: 32px;
              line-height: 18px;
              text-align: center;
            }
          }
          }
          
        }
      .cpsj{
        background: url('../assets/img/cpsj.png');
        background-size: cover;
        background-position: center;
        width: 100%;
        // height: 490px;
        padding-top: 100px;
        display: flex;
        justify-content: center;
        box-sizing: border-box;
        padding-bottom: 100px;
        .le{
          margin-right: 45px;
          .tit{
            font-size: 16px;
            font-family: Alibaba PuHuiTi;
            font-weight: bold;
            color: #333333;
            margin-bottom: 40px;
          }
          .cpsj_list{
            display: flex;
            position: relative;
            margin-bottom: 10px;
            cursor: pointer;
            .name{
              font-weight: bold;
              color: #BABABA;
              width: 65%;
              margin-bottom: 30px;
            }
            img{
              width: 14px;
              height: 14px;
              margin-top: 6px;
              margin-left: 20px;
            }
            .act{
              color: #333333;
            }
          }
          .after::after{
              content: '';
              width: 80%;
              height: 1.2px;
              background: linear-gradient(90deg, #00A0E9 0%, #FFF100 100%);
              position: absolute;
              top: 32px;
              left: 0;
            }
          .line::after{
              content: '';
              width: 80%;
              height: 1.2px;
              background: #E1E1E1;
              position: absolute;
              top: 32px;
              left: 0;
            }
        }
        .ri{
          background-color: #fff;
          width: 30%;
          // height: 280px;
          padding: 30px;
          padding-top: 20px;
          box-sizing: border-box;
          color: #999999;
          text-align: center;
          span{
            padding-top: 30px;
            display: inline-block;
            line-height: 16px;
          }
          .btn{
            width: 79px;
            height: 22px;
            line-height: 22px;
            text-align: center;
            background: #00A0E9;
            border-radius: 11px;
            color: #fff;
            margin: auto;
            margin-top: 25px;
            cursor: pointer;
          }
        }
        }
      .xibao{
          width: 100%;
          background-color: #fff;
          padding: 60px 0 100px 0;
          .box{
            display: flex;
            justify-content: center;
            .item{
              margin-right: 20px;
              text-align: center;
              .img{
                width: 100px;
                height: 100px;
                background: #F8F9FB;
                img{
                  width: 75px;
                  height: 83px;
                  margin-top: 10px;
                }
                .se{
                  width: 55px;
                }
                .sl10{
                  width: 35px;
                  height: 63px;
                  margin-top: 20px;
                }
              }
              .name{
                color: #333333;
                margin: 18px 0 20px 0;
              }
              .butt{
                width: 50px;
                height: 18px;
                line-height: 18px;
                text-align: center;
                background: #00A0E9;
                border-radius: 11px;
                color: #fff;
                margin: auto;
                cursor: pointer;
              }
              .jj{
                background-color: #C9C9C9;
                cursor: none;
              }
            }
          }
        }
    }
  }
  </style>